import './WebsiteIndexEntry.less';
import React, { useRef } from 'react';
import { Icon, Select, Spin } from 'antd';
import { useFetchWebsiteIndexEntriesQuery } from './service';
import useUrlState from '../../hooks/useUrlState';
import { Redirect } from 'react-router-dom';


const { Option } = Select;


export default function WebsiteIndexEntrySelector() {
    const [urlState, setUrlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;
    const selectDomainElement = useRef<Select<string>>(null);

    const { data: websiteIndexEntries, isLoading, isError } = useFetchWebsiteIndexEntriesQuery();
    const isWebsiteGuidValid = websiteGuid && websiteIndexEntries && websiteIndexEntries.map((w) => w.guid).includes(websiteGuid);
    const noWebsiteIndexEntries = !isLoading && websiteIndexEntries && websiteIndexEntries.length === 0;

    const blurSelectElement = () => {
        if (selectDomainElement.current) {
            selectDomainElement.current.blur();
        }
    };

    const handleChange = (selectedDomain: string) => {
        setUrlState({ w_guid: selectedDomain });
    };

    return (
        <>
            {isLoading && <Spin indicator={<Icon type="loading" spin />} />}
            {!isLoading && websiteIndexEntries && websiteIndexEntries.length > 0 && isWebsiteGuidValid && (
                <Select
                    className="deep-analysis-website-entry-select"
                    dropdownClassName="deep-analysis-website-entry-select-dropdown"
                    size="small"
                    ref={selectDomainElement}
                    disabled={isError}
                    placeholder="No domain selected"
                    value={isWebsiteGuidValid ? websiteGuid : undefined}
                    onChange={handleChange}
                    onSelect={blurSelectElement}
                >
                    {websiteIndexEntries.map((websiteIndexEntry) => (
                        <Option
                            value={websiteIndexEntry.guid}
                            key={websiteIndexEntry.guid}
                        >
                            {websiteIndexEntry.domain}
                        </Option>
                    ))}
                </Select>
            )}
            {noWebsiteIndexEntries && <Redirect to={{ pathname: '/deep-analysis/setup-domain' }} />}
        </>
    );
}
